import React, { useState, useEffect } from 'react'
// import "./offerPrint.css"
import { usePurchaseApprovalModel } from "../purchaseApprovalModel";
import { YhOfferPrint } from "@/components/OfferPrint/OfferPrint"
import { purchaseApprovalService } from '../purchaseApprovalService';
import { IDetailList, IPurchaseApprovalDetail } from '../purchaseApprovalType';
import { numberParseChina, formatNum, fmoney, momentFormat } from '@/utils/utils';
import { useDictModel } from '@/views/base/dict/dictModel';
import moment from 'moment';
import useGlobalModel, { getFindItem } from '@/model/globalModel';
export type IMaintenanceAndItemType = {
    total: number
    discount: number
}
export type TotalType = {
    num: number,
    total: number
}
export function PoPrint() {
    const initDesc = { total: 0, discount: 0 }
    const totalDesc = { total: 0, num: 0 }
    const { CustomerData, shopAndOrg: { shopName, shopId, shopCode } } = useGlobalModel()
    const [settlementPartyName, setSettlementPartyName] = useState<string>("")
    const {
        print: visible,
        selectedRow,
        setPrint,
    } = usePurchaseApprovalModel();
    const [formVal, setFormVal] = useState<IPurchaseApprovalDetail>({});
    const [maintenanceList, setMaintenanceList] = useState<IDetailList[]>([]);
    const [maintenanceTotal, setMaintenanceTotal] = useState<IMaintenanceAndItemType>(initDesc);
    const [itemTotal, setItemTotal] = useState<IMaintenanceAndItemType>(initDesc);
    const [total, setTotal] = useState<TotalType>(totalDesc);
    const { getTreeNodeName, getTreeNodeOne } = useDictModel();

    // const { shopAndOrg: { shopCode } } = useGlobalModel()

    useEffect(() => {
        visible && getPoDetailOne()
    }, [visible])
    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await purchaseApprovalService.one(selectedRow.approvalCode as string);
        let { details, ...formVal } = retData;

        let newMaintenanceTotal = { ...maintenanceTotal }
        let newItemTotal = { ...itemTotal }
        let newTotal = { ...total }
        let newdetails: any = details?.map((item, index) => {
            newMaintenanceTotal.total += Number(item.num) * Number(item.price)
            newMaintenanceTotal.discount = item.discountRate as number
            newTotal.num += Number(item.num)
            let { price, discountRate, amount } = item

            return {
                ...item,
                No: index + 1,
                notAmount: Number(item.num) * Number(item.price),
                price: fmoney(price, 2),
                taxPrice: fmoney(formatNum(Number(price) * Number(discountRate) / 100), 2),
                amount: fmoney(amount, 2)
            }
        })

        //这里做最后一行汇总信息展示
        // newdetails?.push({
        //     num: newTotal.num,
        //     No: "",
        //     materialCode: "合计",
        //     amount: fmoney(formVal.totalAmount, 2)
        // })
        if (retData) {
            setMaintenanceList(newdetails as IPurchaseApprovalDetail[] ?? []);
            setFormVal({ ...formVal, })
            setMaintenanceTotal(newMaintenanceTotal)
            setItemTotal(newItemTotal)
        }
    };
    const printNum = async () => {
        await purchaseApprovalService.printNum(selectedRow.id as string);
    }
    const onCancel = () => {
        setPrint(false)
        setMaintenanceList([]);
        setFormVal({})
        setMaintenanceTotal(initDesc)
        setItemTotal(initDesc)
    }
    const columns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '商品编号',
            dataIndex: 'materialCode',
        },
        {
            title: '商品名称',
            dataIndex: 'materialName',
        },
        {
            title: '单位',
            dataIndex: 'unitName',
        },
        {
            title: '数量',
            dataIndex: 'num',
        },
        {
            title: '单价',
            dataIndex: 'price',
        },
        {
            title: '金额',
            dataIndex: 'amount',
        },
        {
            title: '货位',
            dataIndex: 'shelfCode',
        },
    ]

    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: "采购订单号：",
                fieldValue: `${formVal.approvalCode}    (${getTreeNodeName(formVal?.status as string)})`,
            },
            {
                fieldLabel: "制单日期：",
                fieldValue: momentFormat(formVal?.createTime as string)
            },
            {
                fieldLabel: "",
                fieldValue: "",
            },
            {
                fieldLabel: "打印日期：",
                fieldValue: moment(new Date()).format("YYYY-MM-DD HH:mm"),
                className: "li-right"
            },
            {
                fieldLabel: "供应商名称",
                fieldValue: formVal?.supplierName
            },

        ],
        footerPeople: [
            {
                fieldLabel: "制表人：",
                fieldValue: formVal?.createUser
            },
            {
                fieldLabel: "销售：",
                fieldValue: ""
            },
            {
                fieldLabel: "出纳：",
                fieldValue: ""
            },
            {
                fieldLabel: "仓库：",
                fieldValue: maintenanceList[0]?.warehouseName
            },
            {
                fieldLabel: "会计：",
                fieldValue: ""
            },
            // {
            //     fieldLabel: "客户：",
            //     fieldValue: formVal?.customerName
            // },

        ],
        note: [{
            fieldLabel: "备注:",
            fieldValue: formVal?.note
        }],
        Total: {
            numAll: maintenanceList.length,
            receivedAmountChina: numberParseChina(formVal?.totalAmount as any),
            receivedAmount: fmoney(formVal?.totalAmount, 2)
        },

        // Total: [
        //     {
        //         fieldLabel: "大写金额 THE SUM OF：",
        //         fieldValue: numberParseChina(formVal?.receivedAmount as string)
        //     },
        //     {
        //         fieldLabel: "结算类型 Payment Type：",
        //         fieldValue: getTreeNodeName(formVal?.payType as string)
        //     },
        // ],
    }
    const headerTitle = {
        // title: "天津欧豪富港汽车贸易有限公司销售单"
        title: `${shopName}订货单`

    }
    return (
        <YhOfferPrint
            title="订货单打印详情"
            type=""
            visible={visible}
            onClose={onCancel}
            columns={columns}
            printNum={printNum}
            dataSource={maintenanceList.filter(item => item.num !== 0)}
            printShow={printShow}
            headerTitle={headerTitle}
        />
    )
}